module.exports = __webpack_public_path__ + "static/img/bannerOne.fc51971.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bannerOne.png
// module id = pHBP
// module chunks = 1